import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { styled } from '@mui/material/styles';
import Container from '@mui/material/Container';
import Stack from '@mui/material/Stack';
import Alert from '@mui/material/Alert';
import Spin from 'components/Spin';
import BreadcrumbHeader from 'components/BreadcrumbHeader';

const StyledRoot = styled(Box)`
  padding-bottom: 32px;
  overflow: auto;
  flex: 1;
`;

const PageWrapper = ({
  title,
  subtitle,
  actions,
  children,
  loading,
  error,
  breadcrumbs,
  ...other
}) => {
  const actionContent = actions && (
    <Stack direction="row" spacing={0.5} ml="auto">
      {actions}
    </Stack>
  );
  return (
    <StyledRoot id="page-wrapper" {...other}>
      <Container disableGutters maxWidth="xl">
        <Stack spacing={1} px={3} pt={breadcrumbs ? 2 : 3} pb={3}>
          {breadcrumbs && (
            <Stack
              direction="row"
              justifyContent="space-between"
              alignItems="center"
            >
              {breadcrumbs && <BreadcrumbHeader breadcrumbs={breadcrumbs} />}
              {actionContent}
            </Stack>
          )}
          <Box
            display="flex"
            alignItems="center"
            justifyContent="space-between"
          >
            <Box flex={1}>
              <Typography gutterBottom={!!subtitle} variant="h2">
                {title}
              </Typography>
              <Typography color="text.secondary">{subtitle}</Typography>
            </Box>
            {!breadcrumbs && actionContent}
          </Box>
        </Stack>
        <Box px={3} mb={4}>
          {error && (
            <Alert sx={{ mb: 2 }} severity="error">
              {error}
            </Alert>
          )}
          {loading ? <Spin spinning /> : children}
        </Box>
      </Container>
    </StyledRoot>
  );
};

export default PageWrapper;
